import { isAddress } from 'viem';

export const parseIntToBoolean = (value: string): boolean => {
  return !!parseInt(value || '0', 10);
};

export const isTimeAfter = (epoch: number): boolean => {
  return Math.floor(Date.now() / 1000) > epoch;
};

const commitHash = (process.env.NEXT_PUBLIC_COMMIT_HASH || 'unknown').slice(
  0,
  7
);

const fixHostUrl = (url: string, envName: string) => {
  if (!url) {
    throw new Error(`Environment variable ${envName} is not defined.`);
  }
  return url.endsWith('/') ? url.slice(0, -1) : url;
};

export const appConfig = {
  commitHash,
  isProduction: process.env.NEXT_PUBLIC_NODE_ENV === 'production',
  dynaVaults: {
    whatAreFees: process.env.NEXT_PUBLIC_GITBOOK_WHAT_ARE_FEES,
    createVault: {
      whitelist: (process.env.NEXT_PUBLIC_VAULT_CREATE_WHITELIST || '')
        .split(',')
        .filter((addr) => isAddress(addr))
        .map((addr) => addr.toLowerCase()),
      minimumDeposit:
        process.env.NEXT_PUBLIC_VAULT_CREATE_MINIMUM_DEPOSIT || '0.00025',
    },
    vaultRegistryMap: {
      8453: process.env.NEXT_PUBLIC_VAULT_REGISTRY_8453 || '',
    },
  },
  staticAssetsHost: fixHostUrl(
    process.env.NEXT_PUBLIC_STATIC_ASSETS_BUCKET ?? '',
    'NEXT_PUBLIC_STATIC_ASSETS_BUCKET'
  ),
  usersSVCHost: process.env.NEXT_PUBLIC_USERS_SVC || '',
  featureFlags: {
    ENABLE_VAULT_CREATE: parseIntToBoolean(
      process.env.NEXT_PUBLIC_ENABLE_VAULT_CREATE || '0'
    ),
    ENABLE_BANNER: parseIntToBoolean(process.env.NEXT_PUBLIC_IS_BANNER || '0'),
  },
} as const;
